import React from "react";
import { Braces, CircleAlert, KeyRound, Send } from "lucide-react";
import { API_BASE_URL } from "../api/fetchApi";
import { getLang } from "../i18n";

const requestExample = `curl --request POST \\
  '${API_BASE_URL}/api/message?token=YOUR_API_TOKEN' \\
  --header 'Content-Type: application/json' \\
  --data '{
    "phone": ["2189XXXXXXXX"],
    "message": "مرحباً، هذه رسالة من واتسي"
  }'`;

const responseExample = `{
  "message": "Messages are being sent in the background.",
  "client_count": 1,
  "estimated_time": "a few seconds"
}`;

export default function ApiDocsCenter() {
  const isArabic = getLang() === "ar";

  return (
    <div className="dashboard-stack">
      <section className="dashboard-hero api-hero">
        <div>
          <span className="eyebrow eyebrow-light">API v1</span>
          <h2>{isArabic ? "اربط نظامك بإرسال رسائل واتساب" : "Send WhatsApp messages from your system"}</h2>
          <p>{isArabic ? "هذا الدليل مطابق لنقطة الإرسال الحالية في الخادم. اختبر أولاً برقم واحد قبل الإرسال لقائمة كبيرة." : "This guide matches the current server endpoint. Test with one number before sending to a larger list."}</p>
        </div>
        <span className="hidden rounded-2xl border border-white/10 bg-white/5 p-5 text-teal-100 sm:block"><Braces size={34} /></span>
      </section>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-[0.72fr_1.28fr]">
        <aside className="panel-card h-fit">
          <span className="eyebrow">{isArabic ? "البدء" : "Getting started"}</span>
          <h3 className="mt-1 text-lg font-semibold">{isArabic ? "المتطلبات" : "Requirements"}</h3>
          <ul className="mt-5 space-y-4 text-sm leading-6 text-slate-600">
            <li className="flex gap-3"><KeyRound className="mt-0.5 shrink-0 text-teal-700" size={18} /><span>{isArabic ? "استخدم رمز API الخاص بالحساب في معامل token. لا تشاركه في كود الواجهة أو المستودعات العامة." : "Pass your account API token in the token query parameter. Never expose it in frontend code or public repositories."}</span></li>
            <li className="flex gap-3"><Send className="mt-0.5 shrink-0 text-teal-700" size={18} /><span>{isArabic ? "يجب أن تكون جلسة واتساب متصلة وأن توجد حصة رسائل نشطة." : "Your WhatsApp session must be connected with an active message quota."}</span></li>
            <li className="flex gap-3"><CircleAlert className="mt-0.5 shrink-0 text-amber-600" size={18} /><span>{isArabic ? "أرقام الهاتف ترسل كمصفوفة وبالصيغة الدولية دون علامة +." : "Send phone numbers as an array in international format without the + sign."}</span></li>
          </ul>
        </aside>

        <section className="panel-card overflow-hidden">
          <div className="flex flex-wrap items-center gap-3">
            <span className="rounded-md bg-emerald-100 px-2.5 py-1 font-mono text-xs font-bold text-emerald-800">POST</span>
            <code className="break-all text-sm text-slate-700">/api/message?token=YOUR_API_TOKEN</code>
          </div>

          <h3 className="mb-2 mt-7 text-sm font-semibold text-slate-900">{isArabic ? "مثال الطلب" : "Request example"}</h3>
          <pre className="overflow-x-auto rounded-xl bg-slate-950 p-4 text-left font-mono text-xs leading-6 text-slate-200" dir="ltr"><code>{requestExample}</code></pre>

          <h3 className="mb-2 mt-7 text-sm font-semibold text-slate-900">{isArabic ? "استجابة ناجحة (202)" : "Successful response (202)"}</h3>
          <pre className="overflow-x-auto rounded-xl bg-slate-950 p-4 text-left font-mono text-xs leading-6 text-slate-200" dir="ltr"><code>{responseExample}</code></pre>

          <div className="notice notice-warning mt-5">
            {isArabic ? "الاستجابة 202 تعني أن الخادم قبل المهمة وسيكمل الإرسال في الخلفية، وليست تأكيداً بوصول كل رسالة." : "A 202 response means the server accepted the job and will process it in the background; it does not confirm delivery of every message."}
          </div>
        </section>
      </div>
    </div>
  );
}
